/**
 * Директива стилизованного scroll
 *
 * @package Directive
 * @version 1.0
 * @author Bolotov I.P.
 * @since 18.07.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import {Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import {AppService} from '../../../app/app.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Directive({
    selector: '[customScroll]',
    standalone: true
})
export class CustomScrollDirective implements OnInit {
    /** Обработчик событий */
    private subscribe: any;

    @Input() overflowY: boolean = false;

    @Input() overflowX: boolean = false;

    /**
     * Событие клика на ветку
     * @param $event - событие
     */
    @HostListener('scroll', ['$event'])
    onScroll($event) {
        if (this.deviceService.isMobile()) {
            return;
        }
        this.showTrack();
    }

    /**
     * Событие клика на ветку
     * @param $event - событие
     */
    @HostListener('mouseenter', ['$event'])
    onMouseover($event) {

        if (this.deviceService.isMobile()) {
            return;
        }

        let style = 'overlay';

        if (this.appService.browseName === 'firefox'){
            style = 'auto';
        }


        if (this.overflowY) {
            this.element.nativeElement.style.overflowY = style;
        }

        if (this.overflowX) {
            this.element.nativeElement.style.overflowX = style;
        }
    }

    /**
     * Событие клика на ветку
     * @param $event - событие
     */
    @HostListener('mouseleave', ['$event'])
    onMouseleave($event) {

        if (this.deviceService.isMobile()) {
            return;
        }

        if (this.overflowY) {
           this.element.nativeElement.style.overflowY = 'hidden';
        }

        if (this.overflowX) {
           this.element.nativeElement.style.overflowX = 'hidden';
        }
    }

    constructor(private element: ElementRef, private renderer: Renderer2,
                private readonly deviceService: DeviceDetectorService,
                public appService: AppService
    ) {
    }

    /**
     * Вешаем класс
     */
    ngOnInit(): void {
        this.element.nativeElement.parentElement.classList.add('customScroll');

        if (this.deviceService.isMobile()) {
            return;
        }

        if (this.overflowY) {
            this.element.nativeElement.style.overflowY = 'hidden';
        }

        if (this.overflowX) {
            this.element.nativeElement.style.overflowX = 'hidden';
        }
    }

    /**
     * Отобразить полосу прокрутки
     */
    showTrack() {
        this.element.nativeElement.parentElement.classList.add('scrollbar-track-show');
        clearTimeout(this.subscribe);
        this.subscribe = setTimeout(() => {
            if (this.element.nativeElement?.parentElement?.classList) {
                this.element.nativeElement.parentElement.classList.remove('scrollbar-track-show');
            }
        }, 1500);
    }
}

